import apiClient from './apiClient';

class ApiTokenService {
  async listTokens() {
    try {
      return await apiClient.get('/api_tokens');
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to fetch tokens');
    }
  }

  async createToken({ name, jiraAccountId }) {
    try {
      return await apiClient.post('/api_tokens', {
        name,
        jira_account_id: jiraAccountId,
      });
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to create token');
    }
  }

  async revokeToken(id) {
    try {
      return await apiClient.delete(`/api_tokens/${id}`);
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to revoke token');
    }
  }
}

export const apiTokenService = new ApiTokenService();